import React, { useEffect } from 'react';
import { logError } from 'Utils/Logger';
import './PayPalButton.css';

export const PayPalButton = ({ onApprove, onError, onClick, idName, submitButtonText }) => {
  const handleShippingChange = (data, { resolve, reject }) => {
    const {
      shipping_address: { country_code: country },
    } = data;
    return country !== 'US' ? reject() : resolve();
  };

  useEffect(() => {
    const initPaypalButtons = async () => {
      try {
        const style = { color: 'silver', height: 50, shape: 'pill' };
        const btn = await paypal.Buttons({
          style,
          createOrder: onClick,
          onApprove,
          onError,
          onShippingChange: handleShippingChange,
        });
        await btn.render(`#${idName}`);
      } catch (error) {
        logError(error);
      }
    };
    initPaypalButtons();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id={idName}>
      <span className="submitButtonText">{submitButtonText}</span>
    </div>
  );
};
